import { Clock, Percent, Star, Truck, Shield, Award } from 'lucide-react'

const Guarantees = () => {
	return (
		<div className='w-full mt-12 lg:mt-16 mb-12 lg:mb-16 px-6'>
			<div className='max-w-7xl mx-auto'>
				<div className='bg-gradient-to-br from-white via-gray-50/50 to-white rounded-3xl border border-gray-100 p-6 lg:p-12 shadow-2xl relative overflow-hidden'>
					<div className='absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-red-50/30 to-transparent rounded-full -translate-y-48 translate-x-48'></div>
					<div className='absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-gray-50/40 to-transparent rounded-full translate-y-36 -translate-x-36'></div>

					<div className='relative z-10'>
						<div className='text-center mb-10 lg:mb-12'>
							<div className='inline-flex items-center gap-2 bg-red-50 px-4 py-2 rounded-full mb-4'>
								<Award className='w-4 h-4 text-red-600' />
								<span className='text-red-600 font-bold text-xs uppercase tracking-wide'>
									Garantías Exclusivas
								</span>
							</div>

							<h4 className='text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 mb-4 tracking-tight leading-tight'>
								¿Por qué elegir{' '}
								<span className='relative'>
									<span className='text-red-600'>
										SportCenter<span className='text-black'>Shop</span>
									</span>
									<div className='absolute -bottom-1 left-0 w-full h-2 bg-gradient-to-r from-red-100 to-red-200 -z-10 transform -skew-x-12 rounded-sm'></div>
								</span>
								?
							</h4>
							<p className='text-gray-600 text-base lg:text-lg max-w-2xl mx-auto font-medium'>
								Beneficios exclusivos que solo encontrarás en SportCenter Shop
							</p>
							<div className='w-20 h-1 bg-gradient-to-r from-red-500 to-red-600 mx-auto rounded-full mt-4'></div>
						</div>

						<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-10'>
							<div className='group'>
								<div className='bg-white rounded-3xl p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-3 border border-gray-50 relative overflow-hidden'>
									<div className='absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-red-50 to-transparent rounded-full -translate-y-12 translate-x-12'></div>

									<div className='relative z-10 flex flex-col items-center text-center'>
										<div className='w-16 h-16 bg-gradient-to-br from-red-50 to-red-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-gradient-to-br group-hover:from-red-100 group-hover:to-red-200 transition-all duration-500 shadow-inner'>
											<div className='w-12 h-12 bg-gradient-to-br from-red-600 to-red-700 rounded-full flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-500 shadow-lg'>
												<Truck className='w-6 h-6' />
											</div>
										</div>

										<h5 className='font-black text-gray-900 mb-2 text-lg lg:text-xl group-hover:text-red-600 transition-colors duration-500 tracking-tight'>
											Envío Express Gratis
										</h5>
										<p className='text-gray-600 font-medium text-sm lg:text-base leading-relaxed mb-3'>
											Recibe tus productos en 24-48 horas sin costo adicional
										</p>

										<div className='bg-red-50 px-3 py-1 rounded-full'>
											<span className='text-red-600 font-bold text-xs'>
												🚚 Entrega Garantizada
											</span>
										</div>
									</div>
								</div>
							</div>

							<div className='group'>
								<div className='bg-white rounded-3xl p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-3 border border-gray-50 relative overflow-hidden'>
									<div className='absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-gray-50 to-transparent rounded-full -translate-y-12 translate-x-12'></div>

									<div className='relative z-10 flex flex-col items-center text-center'>
										<div className='w-16 h-16 bg-gradient-to-br from-gray-50 to-gray-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-gradient-to-br group-hover:from-red-50 group-hover:to-red-100 transition-all duration-500 shadow-inner'>
											<div className='w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-800 group-hover:bg-gradient-to-br group-hover:from-red-600 group-hover:to-red-700 rounded-full flex items-center justify-center text-white group-hover:scale-110 transition-all duration-500 shadow-lg'>
												<Shield className='w-6 h-6' />
											</div>
										</div>

										<h5 className='font-black text-gray-900 mb-2 text-lg lg:text-xl group-hover:text-red-600 transition-colors duration-500 tracking-tight'>
											Compra 100% Segura
										</h5>
										<p className='text-gray-600 font-medium text-sm lg:text-base leading-relaxed mb-3'>
											Protección total en tus compras con garantía de devolución
										</p>

										<div className='bg-gray-50 group-hover:bg-red-50 px-3 py-1 rounded-full transition-colors duration-500'>
											<span className='text-gray-700 group-hover:text-red-600 font-bold text-xs transition-colors duration-500'>
												🔒 SSL Certificado
											</span>
										</div>
									</div>
								</div>
							</div>

							<div className='group md:col-span-2 lg:col-span-1'>
								<div className='bg-white rounded-3xl p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-3 border border-gray-50 relative overflow-hidden'>
									<div className='absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-yellow-50 to-transparent rounded-full -translate-y-12 translate-x-12'></div>

									<div className='relative z-10 flex flex-col items-center text-center'>
										<div className='w-16 h-16 bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-gradient-to-br group-hover:from-red-50 group-hover:to-red-100 transition-all duration-500 shadow-inner'>
											<div className='w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 group-hover:bg-gradient-to-br group-hover:from-red-600 group-hover:to-red-700 rounded-full flex items-center justify-center text-white group-hover:scale-110 transition-all duration-500 shadow-lg'>
												<Award className='w-6 h-6' />
											</div>
										</div>

										<h5 className='font-black text-gray-900 mb-2 text-lg lg:text-xl group-hover:text-red-600 transition-colors duration-500 tracking-tight'>
											Productos Premium
										</h5>
										<p className='text-gray-600 font-medium text-sm lg:text-base leading-relaxed mb-3'>
											Solo marcas reconocidas y productos certificados de la más
											alta calidad
										</p>

										<div className='bg-yellow-50 group-hover:bg-red-50 px-3 py-1 rounded-full transition-colors duration-500'>
											<span className='text-yellow-600 group-hover:text-red-600 font-bold text-xs transition-colors duration-500'>
												⭐ Calidad Certificada
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className='relative'>
							<div className='bg-gradient-to-r from-red-600 via-red-600 to-red-700 rounded-3xl p-6 lg:p-8 text-center shadow-2xl relative overflow-hidden'>
								<div className='absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 -translate-x-16'></div>
								<div className='absolute bottom-0 right-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 translate-x-12'></div>

								<div className='relative z-10'>
									<h6 className='text-white font-black text-lg lg:text-xl mb-4 tracking-tight'>
										🔥 Ofertas Exclusivas Disponibles
									</h6>

									<div className='flex flex-col sm:flex-row items-center justify-center gap-4 lg:gap-6 text-white'>
										<div className='flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full hover:bg-white/20 transition-colors duration-300'>
											<Clock className='w-5 h-5' />
											<span className='font-bold text-sm'>
												Ofertas por tiempo limitado
											</span>
										</div>

										<div className='hidden sm:block w-px h-6 bg-white/30'></div>

										<div className='flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full hover:bg-white/20 transition-colors duration-300'>
											<Percent className='w-5 h-5' />
											<span className='font-bold text-sm'>
												Hasta 50% de descuento
											</span>
										</div>

										<div className='hidden sm:block w-px h-6 bg-white/30'></div>

										<div className='flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full hover:bg-white/20 transition-colors duration-300'>
											<Star className='w-5 h-5 fill-current' />
											<span className='font-bold text-sm'>Stock limitado</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Guarantees
